import React from 'react'
import Slide from '@material-ui/core/Slide/index'

import RestaurantFormSearch from './elements/RestaurantFormSearch'
import RestaurantFormAvailability from './elements/RestaurantFormAvailability'
import RestaurantFormActive from './elements/RestaurantFormActive'

import _ from 'lodash'

const RestaurantForm = props => {
  const {
    configData,
    activeStep,
    isActiveReservation,
    activeReservation,
    restaurantVenueId,
    restaurantKey,
    restaurantToggled,
    reservationTime,
    handleReservationTime,
    reservationParty,
    handleReservationParty,
    reservationDate,
    reservationDateFocused,
    handleReservationDate,
    handleReservationDateFocus,
    restaurantAvailabilityData,
    handleFetchRestaurantAvailability,
    handleClose,
    handleBackToSearch,
    activeReservationTime,
    handleActiveReservationTime,
    handleSetActiveRestaurant,
    handleRemoveActiveRestaurant,
    handleContinuePayment,
  } = props

  let isRestaurantClosed = null,
      restaurantTimes = null

  if (
    restaurantAvailabilityData &&
    restaurantAvailabilityData.availability &&
    restaurantAvailabilityData.availability[restaurantVenueId]
  ) {
    const currentRestaurant = restaurantAvailabilityData.availability[restaurantVenueId]

    if (currentRestaurant.isClosed) {
      isRestaurantClosed = currentRestaurant.isClosed
    }

    if(!_.isEmpty(currentRestaurant.times)) {
      restaurantTimes = currentRestaurant.times
    }
  }

   return (
     <Slide
       direction="up"
       in={ restaurantToggled }
       timeout={ 600 }
       mountOnEnter={ true }
       unmountOnExit={ true }
     >
      <div className={ isActiveReservation ? "bk-flow-restaurants__form active" : "bk-flow-restaurants__form" }>
        { isActiveReservation ?
          <RestaurantFormActive
            configData={ configData }
            activeStep={ activeStep }
            activeReservation={ activeReservation }
            restaurantVenueId={ restaurantVenueId }
            handleRemoveActiveRestaurant={ handleRemoveActiveRestaurant }
            handleContinuePayment={ handleContinuePayment }
          />
        : !isRestaurantClosed && !_.isEmpty(restaurantTimes) ?
          <RestaurantFormAvailability
            configData={ configData }
            isActiveReservation={ isActiveReservation }
            restaurantVenueId={ restaurantVenueId }
            restaurantTimes={ restaurantTimes }
            handleBackToSearch={ handleBackToSearch }
            handleClose={ handleClose }
            activeReservationTime={ activeReservationTime }
            handleActiveReservationTime={ handleActiveReservationTime }
            handleSetActiveRestaurant={ handleSetActiveRestaurant }
          />
        :
          <RestaurantFormSearch
            configData={ configData }
            restaurantVenueId={ restaurantVenueId}
            restaurantKey={ restaurantKey}
            isRestaurantClosed={ isRestaurantClosed }
            handleBackToSearch={ handleBackToSearch }
            handleClose={ handleClose }
            reservationDate={ reservationDate }
            reservationDateFocused={ reservationDateFocused}
            handleReservationDate={ handleReservationDate }
            handleReservationDateFocus={ handleReservationDateFocus }
            reservationParty={ reservationParty }
            handleReservationParty={ handleReservationParty }
            reservationTime={ reservationTime }
            handleReservationTime={ handleReservationTime }
            restaurantAvailabilityData={ restaurantAvailabilityData }
            handleFetchRestaurantAvailability={ handleFetchRestaurantAvailability }
          />
        }
      </div>
     </Slide>
   )
}

export default RestaurantForm


// WEBPACK FOOTER //
// ./src/components/forms/restaurantForm/RestaurantForm.js